// extracted by mini-css-extract-plugin
module.exports = {"root":"_58a839"};